export default __webpack_public_path__ + "static/struthless-ibis-drawing-cd3b39215fdf45a5e88384055337df09.webp";